export default function ChapterDetail9(props) {
  document.title = props.text + " | Arisu";
  
	return (
    <>
      <p className="indent-8">
        “You can’t think how glad I am to see you again, you dear old
        thing!” said the Duchess, as she tucked her arm affectionately into
        Alice’s, and they walked off together.
      </p>
      <p className="indent-8">
        Alice was very glad to find her in such a pleasant temper, and thought to
        herself that perhaps it was only the pepper that had made her so savage when
        they met in the kitchen.
      </p>
      <p className="indent-8">
        “When <i>I’m</i> a Duchess,” she said to herself, (not in a
        very hopeful tone though), “I won’t have any pepper in my kitchen
        <i>at all</i>. Soup does very well without—Maybe it’s always pepper
        that makes people hot-tempered,” she went on, very much pleased at having
        found out a new kind of rule, “and vinegar that makes them sour—and
        camomile that makes them bitter—and—and barley-sugar and such
        things that make children sweet-tempered. I only wish people knew <i>that</i>:
        then they wouldn’t be so stingy about it, you know—”
      </p>
      <p className="indent-8">
        She had quite forgotten the Duchess by this time, and was a little startled
        when she heard her voice close to her ear. “You’re thinking about
        something, my dear, and that makes you forget to talk. I can’t tell you
        just now what the moral of that is, but I shall remember it in a bit.”
      </p>
      <p className="indent-8">
        “Perhaps it hasn’t one,” Alice ventured to remark.
      </p>
      <p className="indent-8">
        “Tut, tut, child!” said the Duchess. “Everything’s got
        a moral, if only you can find it.” And she squeezed herself up closer to
        Alice’s side as she spoke.
      </p>
      <p className="indent-8">
        Alice did not much like keeping so close to her: first, because the Duchess was
        <i>very</i> ugly; and secondly, because she was exactly the right height to
        rest her chin upon Alice’s shoulder, and it was an uncomfortably sharp
        chin. However, she did not like to be rude, so she bore it as well as she
        could.
      </p>
      <p className="indent-8">
        “The game’s going on rather better now,” she said, by way of
        keeping up the conversation a little.
      </p>
      <p className="indent-8">
        “’Tis so,” said the Duchess: “and the moral of that
        is—‘Oh, ’tis love, ’tis love, that makes the world go
        round!’”
      </p>
      <p className="indent-8">
        “Somebody said,” Alice whispered, “that it’s done by
        everybody minding their own business!”
      </p>
      <p className="indent-8">
        “Ah, well! It means much the same thing,” said the Duchess, digging
        her sharp little chin into Alice’s shoulder as she added, “and the
        moral of <i>that</i> is—‘Take care of the sense, and the sounds
        will take care of themselves.’”
      </p>
      <p className="indent-8">
        “How fond she is of finding morals in things!” Alice thought to
        herself.
      </p>
      <p className="indent-8">
        “I dare say you’re wondering why I don’t put my arm round
        your waist,” the Duchess said after a pause: “the reason is, that
        I’m doubtful about the temper of your flamingo. Shall I try the
        experiment?”
      </p>
      <p className="indent-8">
        “He might bite,” Alice cautiously replied, not feeling at all
        anxious to have the experiment tried.
      </p>
      <p className="indent-8">
        “Very true,” said the Duchess: “flamingoes and mustard both
        bite. And the moral of that is—‘Birds of a feather flock
        together.’”
      </p>
      <p className="indent-8">
        “Only mustard isn’t a bird,” Alice remarked.
      </p>
      <p className="indent-8">
        “Right, as usual,” said the Duchess: “what a clear way you
        have of putting things!”
      </p>
      <p className="indent-8">
        “It’s a mineral, I <i>think</i>,” said Alice.
      </p>
      <p className="indent-8">
        “Of course it is,” said the Duchess, who seemed ready to agree to
        everything that Alice said; “there’s a large mustard-mine near
        here. And the moral of that is—‘The more there is of mine, the less
        there is of yours.’”
      </p>
      <p className="indent-8">
        “Oh, I know!” exclaimed Alice, who had not attended to this last
        remark, “it’s a vegetable. It doesn’t look like one, but it
        is.”
      </p>
      <p className="indent-8">
        “I quite agree with you,” said the Duchess; “and the moral of
        that is—‘Be what you would seem to be’—or if
        you’d like it put more simply—‘Never imagine yourself not to
        be otherwise than what it might appear to others that what you were or might
        have been was not otherwise than what you had been would have appeared to them
        to be otherwise.’”
      </p>
      <p className="indent-8">
        “I think I should understand that better,” Alice said very
        politely, “if I had it written down: but I can’t quite follow it as
        you say it.”
      </p>
      <p className="indent-8">
        “That’s nothing to what I could say if I chose,” the Duchess
        replied, in a pleased tone.
      </p>
      <p className="indent-8">
        “Pray don’t trouble yourself to say it any longer than that,”
        said Alice.
      </p>
      <p className="indent-8">
        “Oh, don’t talk about trouble!” said the Duchess. “I
        make you a present of everything I’ve said as yet.”
      </p>
      <p className="indent-8">
        “A cheap sort of present!” thought Alice. “I’m glad
        they don’t give birthday presents like that!” But she did not
        venture to say it out loud.
      </p>
      <p className="indent-8">
        “Thinking again?” the Duchess asked, with another dig of her sharp
        little chin.
      </p>
      <p className="indent-8">
        “I’ve a right to think,” said Alice sharply, for she was
        beginning to feel a little worried.
      </p>
      <p className="indent-8">
        “Just about as much right,” said the Duchess, “as pigs have
        to fly; and the m—”
      </p>
      <p className="indent-8">
        But here, to Alice’s great surprise, the Duchess’s voice died away,
        even in the middle of her favourite word ‘moral,’ and the arm that
        was linked into hers began to tremble. Alice looked up, and there stood the
        Queen in front of them, with her arms folded, frowning like a thunderstorm.
      </p>
      <p className="indent-8">
        “A fine day, your Majesty!” the Duchess began in a low, weak voice.
      </p>
      <p className="indent-8">
        “Now, I give you fair warning,” shouted the Queen, stamping on the
        ground as she spoke; “either you or your head must be off, and that in
        about half no time! Take your choice!”
      </p>
      <p className="indent-8">
        The Duchess took her choice, and was gone in a moment.
      </p>
      <p className="indent-8">
        “Let’s go on with the game,” the Queen said to Alice; and
        Alice was too much frightened to say a word, but slowly followed her back to
        the croquet-ground.
      </p>
      <p className="indent-8">
        The other guests had taken advantage of the Queen’s absence, and were
        resting in the shade: however, the moment they saw her, they hurried back to
        the game, the Queen merely remarking that a moment’s delay would cost
        them their lives.
      </p>
      <p className="indent-8">
        All the time they were playing the Queen never left off quarrelling with the
        other players, and shouting “Off with his head!” or “Off with
        her head!” Those whom she sentenced were taken into custody by the
        soldiers, who of course had to leave off being arches to do this, so that by
        the end of half an hour or so there were no arches left, and all the players,
        except the King, the Queen, and Alice, were in custody and under sentence of
        execution.
      </p>
      <p className="indent-8">
        Then the Queen left off, quite out of breath, and said to Alice, “Have
        you seen the Mock Turtle yet?”
      </p>
      <p className="indent-8">
        “No,” said Alice. “I don’t even know what a Mock Turtle
        is.”
      </p>
      <p className="indent-8">
        “It’s the thing Mock Turtle Soup is made from,” said the
        Queen.
      </p>
      <p className="indent-8">
        “I never saw one, or heard of one,” said Alice.
      </p>
      <p className="indent-8">
        “Come on, then,” said the Queen, “and he shall tell you his
        history,”
      </p>
      <p className="indent-8">
        As they walked off together, Alice heard the King say in a low voice, to the
        company generally, “You are all pardoned.” “Come,
        <i>that’s</i> a good thing!” she said to herself, for she had felt
        quite unhappy at the number of executions the Queen had ordered.
      </p>
      <p className="indent-8">
        They very soon came upon a Gryphon, lying fast asleep in the sun. (If you
        don’t know what a Gryphon is, look at the picture.) “Up, lazy
        thing!” said the Queen, “and take this young lady to see the Mock
        Turtle, and to hear his history. I must go back and see after some executions I
        have ordered;” and she walked off, leaving Alice alone with the Gryphon.
        Alice did not quite like the look of the creature, but on the whole she thought
        it would be quite as safe to stay with it as to go after that savage Queen: so
        she waited.
      </p>
      <p className="indent-8">
        The Gryphon sat up and rubbed its eyes: then it watched the Queen till she was
        out of sight: then it chuckled. “What fun!” said the Gryphon, half
        to itself, half to Alice.
      </p>
      <p className="indent-8">
        “What <i>is</i> the fun?” said Alice.
      </p>
      <p className="indent-8">
        “Why, <i>she</i>,” said the Gryphon. “It’s all her
        fancy, that: they never executes nobody, you know. Come on!”
      </p>
      <p className="indent-8">
        “Everybody says ‘come on!’ here,” thought Alice, as she
        went slowly after it: “I never was so ordered about in all my life,
        never!”
      </p>
      <p className="indent-8">
        They had not gone far before they saw the Mock Turtle in the distance, sitting
        sad and lonely on a little ledge of rock, and, as they came nearer, Alice could
        hear him sighing as if his heart would break. She pitied him deeply.
        “What is his sorrow?” she asked the Gryphon, and the Gryphon
        answered, very nearly in the same words as before, “It’s all his
        fancy, that: he hasn’t got no sorrow, you know. Come on!”
      </p>
      <p className="indent-8">
        So they went up to the Mock Turtle, who looked at them with large eyes full of
        tears, but said nothing.
      </p>
      <p className="indent-8">
        “This here young lady,” said the Gryphon, “she wants for to
        know your history, she do.”
      </p>
      <p className="indent-8">
        “I’ll tell it her,” said the Mock Turtle in a deep, hollow
        tone: “sit down, both of you, and don’t speak a word till
        I’ve finished.”
      </p>
      <p className="indent-8">
        So they sat down, and nobody spoke for some minutes. Alice thought to herself,
        “I don’t see how he can <i>ever</i> finish, if he doesn’t
        begin.” But she waited patiently.
      </p>
      <p className="indent-8">
        “Once,” said the Mock Turtle at last, with a deep sigh, “I
        was a real Turtle.”
      </p>
      <p className="indent-8">
        These words were followed by a very long silence, broken only by an occasional
        exclamation of “Hjckrrh!” from the Gryphon, and the constant heavy
        sobbing of the Mock Turtle. Alice was very nearly getting up and saying,
        “Thank you, sir, for your interesting story,” but she could not
        help thinking there <i>must</i> be more to come, so she sat still and said
        nothing.
      </p>
      <p className="indent-8">
        “When we were little,” the Mock Turtle went on at last, more
        calmly, though still sobbing a little now and then, “we went to school in
        the sea. The master was an old Turtle—we used to call him
        Tortoise—”
      </p>
      <p className="indent-8">
        “Why did you call him Tortoise, if he wasn’t one?” Alice
        asked.
      </p>
      <p className="indent-8">
        “We called him Tortoise because he taught us,” said the Mock Turtle
        angrily: “really you are very dull!”
      </p>
      <p className="indent-8">
        “You ought to be ashamed of yourself for asking such a simple
        question,” added the Gryphon; and then they both sat silent and looked at
        poor Alice, who felt ready to sink into the earth. At last the Gryphon said to
        the Mock Turtle, “Drive on, old fellow! Don’t be all day about
        it!” and he went on in these words:
      </p>
      <p className="indent-8">
        “Yes, we went to school in the sea, though you mayn’t believe
        it—”
      </p>
      <p className="indent-8">
        “I never said I didn’t!” interrupted Alice.
      </p>
      <p className="indent-8">
        “You did,” said the Mock Turtle.
      </p>
      <p className="indent-8">
        “Hold your tongue!” added the Gryphon, before Alice could speak
        again. The Mock Turtle went on.
      </p>
      <p className="indent-8">
        “We had the best of educations—in fact, we went to school every
        day—”
      </p>
      <p className="indent-8">
        “<i>I’ve</i> been to a day-school, too,” said Alice;
        “you needn’t be so proud as all that.”
      </p>
      <p className="indent-8">
        “With extras?” asked the Mock Turtle a little anxiously.
      </p>
      <p className="indent-8">
        “Yes,” said Alice, “we learned French and music.”
      </p>
      <p className="indent-8">
        “And washing?” said the Mock Turtle.
      </p>
      <p className="indent-8">
        “Certainly not!” said Alice indignantly.
      </p>
      <p className="indent-8">
        “Ah! then yours wasn’t a really good school,” said the Mock
        Turtle in a tone of great relief. “Now at <i>ours</i> they had at the end
        of the bill, ‘French, music, <i>and
          washing</i>—extra.’”
      </p>
      <p className="indent-8">
        “You couldn’t have wanted it much,” said Alice; “living
        at the bottom of the sea.”
      </p>
      <p className="indent-8">
        “I couldn’t afford to learn it.” said the Mock Turtle with a
        sigh. “I only took the regular course.”
      </p>
      <p className="indent-8">
        “What was that?” inquired Alice.
      </p>
      <p className="indent-8">
        “Reeling and Writhing, of course, to begin with,” the Mock Turtle
        replied; “and then the different branches of Arithmetic—Ambition,
        Distraction, Uglification, and Derision.”
      </p>
      <p className="indent-8">
        “I never heard of ‘Uglification,’” Alice ventured to
        say. “What is it?”
      </p>
      <p className="indent-8">
        The Gryphon lifted up both its paws in surprise. “What! Never heard of
        uglifying!” it exclaimed. “You know what to beautify is, I
        suppose?”
      </p>
      <p className="indent-8">
        “Yes,” said Alice doubtfully: “it
        means—to—make—anything—prettier.”
      </p>
      <p className="indent-8">
        “Well, then,” the Gryphon went on, “if you don’t know
        what to uglify is, you <i>are</i> a simpleton.”
      </p>
      <p className="indent-8">
        Alice did not feel encouraged to ask any more questions about it, so she turned
        to the Mock Turtle, and said “What else had you to learn?”
      </p>
      <p className="indent-8">
        “Well, there was Mystery,” the Mock Turtle replied, counting off
        the subjects on his flappers, “—Mystery, ancient and modern, with
        Seaography: then Drawling—the Drawling-master was an old conger-eel, that
        used to come once a week: <i>he</i> taught us Drawling, Stretching, and
        Fainting in Coils.”
      </p>
      <p className="indent-8">
        “What was <i>that</i> like?” said Alice.
      </p>
      <p className="indent-8">
        “Well, I can’t show it you myself,” the Mock Turtle said:
        “I’m too stiff. And the Gryphon never learnt it.”
      </p>
      <p className="indent-8">
        “Hadn’t time,” said the Gryphon: “I went to the
        Classics master, though. He was an old crab, <i>he</i> was.”
      </p>
      <p className="indent-8">
        “I never went to him,” the Mock Turtle said with a sigh: “he
        taught Laughing and Grief, they used to say.”
      </p>
      <p className="indent-8">
        “So he did, so he did,” said the Gryphon, sighing in his turn; and
        both creatures hid their faces in their paws.
      </p>
      <p className="indent-8">
        “And how many hours a day did you do lessons?” said Alice, in a
        hurry to change the subject.
      </p>
      <p className="indent-8">
        “Ten hours the first day,” said the Mock Turtle: “nine the
        next, and so on.”
      </p>
      <p className="indent-8">
        “What a curious plan!” exclaimed Alice.
      </p>
      <p className="indent-8">
        “That’s the reason they’re called lessons,” the Gryphon
        remarked: “because they lessen from day to day.”
      </p>
      <p className="indent-8">
        This was quite a new idea to Alice, and she thought it over a little before she
        made her next remark. “Then the eleventh day must have been a
        holiday?”
      </p>
      <p className="indent-8">
        “Of course it was,” said the Mock Turtle.
      </p>
      <p className="indent-8">
        “And how did you manage on the twelfth?” Alice went on eagerly.
      </p>
      <p className="indent-8">
        “That’s enough about lessons,” the Gryphon interrupted in a
        very decided tone: “tell her something about the games now.”
      </p>
    </>
  )
}